import React from "react";
import Commonbadge from "Components/Common/Commonbadge";
import styles from "../css/volunteerdashboard.module.scss";
import { formatDate } from "helpers/constant";
import {
  AlcoholResult_OPTIONS,
  BloodGroup_OPTIONS,
  EducationLevel_OPTIONS,
  Ethnicity_OPTIONS,
  FoodHabit_OPTIONS,
  Gender_OPTIONS,
  LiterateStatus_OPTIONS,
  MaritalStatus_OPTIONS,
  Occupation_OPTIONS,
  PopulationGroup_OPTIONS,
  PrimaryLanguage_OPTIONS,
  Race_OPTIONS,
  Religion_OPTIONS,
  SMOKING_OPTIONS,
} from "api/modules/common.option";
import { FormFieldConfig } from "Components/Common/CommonForm";
import { Column } from "Components/Common/CommonTableIndexWise";
import { Button, UncontrolledTooltip } from "reactstrap";
import { TabType } from "./volunteer.types";
import { validations } from "validations/FormValidations";

export const VolunteerSections = [
  {
    title: "Personal Information",
    fields: ["fullname", "initials", "gender", "dob", "age"],
  },
  {
    title: "Contact Information",
    fields: ["mobilenum", "email", "address", "state", "city", "pincode"],
  },
  {
    title: "Emergency Details",
    fields: ["emergencyname", "emergencynumber"],
  },
  {
    title: "Medical Information",
    fields: [
      "height",
      "weight",
      "bmi",
      "pulserate",
      "temperature",
      "smoking",
      "alcoholresult",
      "bloodgroup",
      "allergies",
      "medicalhistory",
      "currentmedication",
      "bac",
      "indicatorlightcolor",
      "alcoholunit",
    ],
  },
  {
    title: "Demographics",
    fields: [
      "maritalstatus",
      "ethnicity",
      "religion",
      "occupation",
      "educationlevel",
      "primarylanguage",
      "foodhabit",
      "populationgroup",
      "literatestatus",
      "race",
    ],
  },
];

export const VolunteerFields: FormFieldConfig[] = [
  // ================= PERSONAL DETAILS =================
  {
    name: "fullname",
    label: "Full Name",
    type: "text",
    required: true,
    placeholder: "Enter full name",
    rules: validations.volunteer.fullname,
  },
  {
    name: "initials",
    label: "Initials",
    placeholder: "Enter initials",
    type: "text",
    required: true,
    rules: validations.volunteer.initials,
  },
  {
    name: "gender",
    label: "Gender",
    type: "select",
    options: Gender_OPTIONS,
    required: true,
  },
  {
    name: "dob",
    label: "Date of Birth",
    type: "date",
    required: true,
    optionsProps: {
      maxDate: "today",
    },
  },
  {
    name: "age",
    label: "Age",
    type: "number",
    disabled: true,
  },

  // ================= CONTACT DETAILS =================
  {
    name: "mobilenum",
    label: "Mobile",
    type: "number",
    placeholder: "Enter mobile number",
    required: true,
    rules: validations.volunteer.mobilenum,
  },
  {
    name: "email",
    label: "Email",
    type: "email",
    placeholder: "Enter email address",
    required: true,
    rules: validations.volunteer.email,
  },
  {
    name: "address",
    label: "Address",
    type: "textarea",
    placeholder: "Enter address",
    required: true,
    rules: validations.volunteer.address,
  },
  {
    name: "state",
    label: "State",
    type: "text",
    placeholder: "Enter state",
    required: true,
    rules: validations.volunteer.state,
  },
  {
    name: "city",
    label: "City",
    type: "text",
    placeholder: "Enter city",
    required: true,
    rules: validations.volunteer.city,
  },
  {
    name: "pincode",
    label: "PIN Code",
    type: "number",
    placeholder: "Enter PIN code",
    required: true,
    rules: validations.volunteer.pincode,
  },

  // ================= EMERGENCY =================
  {
    name: "emergencyname",
    label: "Emergency Contact Name",
    type: "text",
    required: true,
    placeholder: "Enter emergency contact name",
    rules: validations.volunteer.emergencyname,
  },
  {
    name: "emergencynumber",
    label: "Emergency Contact Phone",
    type: "number",
    placeholder: "Enter emergency contact phone",
    required: true,
    rules: validations.volunteer.emergencynumber,
  },

  // ================= MEDICAL =================
  {
    name: "height",
    label: "Height (cm)",
    type: "number",
    placeholder: "Enter height in cm",
    required: true,
    rules: validations.volunteer.height,
  },
  {
    name: "weight",
    label: "Weight (kg)",
    type: "number",
    placeholder: "Enter weight in kg",
    required: true,
    rules: validations.volunteer.weight,
  },
  {
    name: "bmi",
    label: "BMI",
    type: "number",
    disabled: true,
  },
  {
    name: "smoking",
    label: "Smoking",
    type: "select",
    options: SMOKING_OPTIONS,
    required: true,
  },
  {
    name: "alcoholresult",
    label: "Alcohol Result",
    type: "select",
    options: AlcoholResult_OPTIONS,
    required: true,
  },
  {
    name: "bac",
    label: "Blood Alcohol Concentration (BAC)",
    placeholder: "Enter alcohol value in mg/dL",
    type: "number",
    required: true,
    rules: validations.volunteer.bac,
  },
  {
    name: "indicatorlightcolor",
    label: "Indicator Light Color",
    placeholder: "Enter indicator light color",
    type: "text",
    required: true,
    rules: validations.volunteer.indicatorlightcolor,
  },
  {
    name: "bloodgroup",
    label: "Blood Group",
    type: "select",
    options: BloodGroup_OPTIONS,
    required: true,
  },
  {
    name: "allergies",
    label: "Allergies",
    type: "textarea",
    placeholder: "Enter any allergies",
    rules: validations.volunteer.allergies,
    required: true,
  },
  {
    name: "medicalhistory",
    label: "Medical History",
    type: "textarea",
    placeholder: "Enter medical history",
    rules: validations.volunteer.medicalhistory,
    required: true,
  },
  {
    name: "currentmedication",
    label: "Current Medication",
    type: "textarea",
    placeholder: "Enter current medication",
    rules: validations.volunteer.currentmedication,
    required: true,
  },
  {
    name: "pulserate",
    label: "Pulse Rate (bpm)",
    type: "number",
    placeholder: "Enter pulse rate",
    required: true,
    rules: validations.volunteer.pulserate,
  },
  {
    name: "temperature",
    label: "Temperature (°C)",
    type: "number",
    placeholder: "Enter temperature",
    required: true,
    rules: validations.volunteer.temperature,
  },

  // ================= DEMOGRAPHICS =================
  {
    name: "maritalstatus",
    label: "Marital Status",
    type: "select",
    options: MaritalStatus_OPTIONS,
    required: true,
  },

  {
    name: "ethnicity",
    label: "Ethnicity",
    type: "select",
    options: Ethnicity_OPTIONS,
    required: true,
  },

  {
    name: "religion",
    label: "Religion",
    type: "select",
    options: Religion_OPTIONS,
    required: true,
  },

  {
    name: "occupation",
    label: "Occupation",
    type: "select",
    options: Occupation_OPTIONS,
    required: true,
  },

  {
    name: "educationlevel",
    label: "Education Level",
    type: "select",
    options: EducationLevel_OPTIONS,
    required: true,
  },

  {
    name: "primarylanguage",
    label: "Primary Language",
    type: "select",
    options: PrimaryLanguage_OPTIONS,
    required: true,
  },

  {
    name: "foodhabit",
    label: "Food Habit",
    type: "select",
    options: FoodHabit_OPTIONS,
    required: true,
  },

  {
    name: "populationgroup",
    label: "Population Group",
    type: "select",
    options: PopulationGroup_OPTIONS,
    required: true,
  },

  {
    name: "literatestatus",
    label: "Literate Status",
    type: "select",
    options: LiterateStatus_OPTIONS,
    required: true,
  },

  {
    name: "race",
    label: "Race",
    type: "select",
    options: Race_OPTIONS,
    required: true,
  },
];

export const renderValue = (value: any) => {
  if (value === null || value === undefined || value === "")
    return <span className="text-muted">—</span>;
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (Array.isArray(value)) return value.join(", ");
  return String(value);
};

export const normalizeVolunteer = (data: any) => {
  if (!data) return;
  const normalized = { ...data };

  Object.keys(data).forEach((key) => {
    const textKey = `${key}text`;

    if (data[textKey]) {
      normalized[key] = data[textKey];
    }
  });

  // alcohol test normalize
  if (normalized.alcoholtest?.length) {
    normalized.alcoholtest = normalized.alcoholtest.map((test: any) => ({
      ...test,
      alcoholresult: test.alcoholresulttext ?? test.alcoholresult,
    }));
  }

  return normalized;
};



export const getFileIcon = (ext?: string) => {
  const extension = ext?.toLowerCase();

  if (extension === "pdf") return "ri-file-pdf-line text-danger";
  if (["jpg", "jpeg", "png"].includes(extension || ""))
    return "ri-image-line text-primary";
  if (["doc", "docx"].includes(extension || ""))
    return "ri-file-word-line text-info";
  if (["xls", "xlsx"].includes(extension || ""))
    return "ri-file-excel-line text-success";

  return "ri-file-line text-secondary";
};

export const availableVolunteerColumn = (
  handleViewClick: (row: any) => void,
  setSelectedVolunteerId: (id: number) => void,
  setVolunteerToAssignName: (name: string) => void,
  toggleAssignModal: () => void,
  canassign?: boolean,
): Column[] => [
    {
      key: "fullname",
      label: "Name",
      type: "link",
      tooltip: true,
      onClick: (row: any) => handleViewClick(row),
    },
    {
      key: "gendertext",
      label: "Gender",
    },
    {
      key: "age",
      label: "Age",
    },
    {
      key: "mobilenum",
      label: "Mobile",
    },
    {
      key: "email",
      label: "Email",
      tooltip: true,
    },
    {
      key: "alcoholresulttext",
      label: "Alcohol Status",
      cell: (row: any) => {
        const isPositive = row.alcoholresulttext === "positive";
        return (
          <span className={`badge ${isPositive ? "bg-danger" : "bg-success"} text-capitalize fs-11`}>
            {row.alcoholresulttext || "N/A"}
          </span>
        )
      }
    },
    // {
    //   key: "alcoholresulttext",
    //   label: "Status",
    //   //
    //   cell: (row: any) => {
    //     const isEligible = row.alcoholresulttext === "negative";
    //     const reason = row.alcoholreason || "Alcohol Failed";

    //     const id = `status-${row.id}`;

    //     return (
    //       <>
    //         <span
    //           id={id}
    //           className={`badge ${isEligible ? "bg-success" : "bg-danger"}`}
    //           style={{ cursor: !isEligible ? "pointer" : "default" }}
    //         >
    //           {isEligible ? "Eligible" : "Not Eligible"}
    //         </span>

    //         {!isEligible && (
    //           <UncontrolledTooltip placement="right" target={id}>
    //             {reason}
    //           </UncontrolledTooltip>
    //         )}
    //       </>
    //     );
    //   },
    // },
    {
      key:"currentstatus",
      label:"Status",
      textCenter: true,
      render: (row: any,) => {
        if (!row) {
          return <span className="text-muted">--</span>;
        }
        return (
          <Commonbadge status={row === 'active' ? 'Available' : row} style={{ fontSize:'12px'}} />
        );
      },
    },
    ...canassign ? [
      {
        key: "assign",
        label: "Assign To Study",
        textCenter: true,
        cell: (row: any) => {
          const isAssigned = !row.canassign;

          return (
            <div className="d-flex justify-content-center align-items-center">
              { isAssigned ? "--" : (
                <Button
                  color="primary"
                  outline
                  size="sm"
                  className="rounded-pill px-3 d-flex align-items-center gap-1 fw-medium"
                  onClick={() => {
                    setSelectedVolunteerId(row.id);
                    setVolunteerToAssignName(row.fullname);
                    toggleAssignModal();
                  }}
                >
                  <i className="ri-user-shared-line fs-14" /> Assign
                </Button>
              )}
            </div>
          );
        },
      },
    ] : [],
  ];

export const assignedVolunteerColumn = (
  handleViewClick: (row: any) => void,
): Column[] => [
    {
      key: "fullname",
      label: "Name",
      type: "link",
      tooltip: true,
      onClick: (row: any) => handleViewClick(row),
    },
    {
      key: "gendertext",
      label: "Gender",
    },
    {
      key: "age",
      label: "Age",
    },
    {
      key: "mobilenum",
      label: "Mobile",
    },
    {
      key: "email",
      label: "Email",
      tooltip: true,
    },
    {
      key:"volunteerstatus",
      label:"Status",
      textCenter: true,
      render: (row: any,) => {
        if (!row) {
          return <span className="text-muted">--</span>;
        }
        return (
          <Commonbadge status={row} style={{ fontSize:'12px'}} />
        );
      },
    },
  ];

export const AssignStudyColumn = (studyOptions: { value: string | number; label: string }[]): FormFieldConfig[] => [{
  name: "studyid",
  label: "Selected Study",
  type: "select",
  placeholder: "Search and select study...",
  options: studyOptions,
  required: true,
  disabled: true,
}
]



export const AttachmentFields = (
  availableOptions: { value: string | number; label: string }[],
  stagedFiles: { file: File }[]
): FormFieldConfig[] => [
    {
      name: "attachmentType",
      label: "Attachment Type",
      type: "select",
      options: availableOptions,
      required: stagedFiles.length === 0,
      rules: {
        required: stagedFiles.length === 0 ? "Please select an attachment type" : false,
      }
    },
    {
      name: "files",
      label: "Upload Files",
      type: "file",
      required: stagedFiles.length === 0,
      rules: {
        required: false, // Override internal React Hook Form required to bypass File object bug
        validate: (value: any) => {
          if (stagedFiles.length > 0 && !value) return true; // Optional if something is already staged
          if (!value) return "Please select at least one file";
          if (Array.isArray(value) && value.length === 0) return "Please select at least one file";
          return true;
        },
      },
    },
  ];


/* ---------------- REACT SELECT STYLES ---------------- */
export const customSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    backgroundColor: "#f3f3f3",
    borderColor: state.isFocused ? "#405189" : "transparent",
    borderRadius: "4px",
    fontSize: "12px",
    minHeight: "27px",
    height: "auto",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#405189",
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: "0 6px",
    fontSize: "12px",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "#495057",
  }),
  placeholder: (base: any) => ({
    ...base,
    color: "#adb5bd",
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    height: "25px",
  }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: "12px",
    padding: "6px 10px",
    minHeight: "25px",
    display: "flex",
    alignItems: "center",
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 9999,
  }),
};


export const volunteerTabs: TabType[] = [
  {
    key: "detail",
    label: "Details",
    icon: "ri-file-list-3-line",
    path: "",
  },
  {
    key: "icf",
    label: "ICF",
    icon: "ri-file-paper-2-line",
    path: "icf",
  },
  {
    key: "test",
    label: "Test",
    icon: "ri-file-chart-line",
    path: "test",
  },
];

/* ==========================================================================
   SVG ICONS - Clean, Custom Inline SVGs matching the layout designs exactly
   ========================================================================== */

export const IconCheckCircle = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

export const IconHourglass = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 2h14"></path>
    <path d="M5 22h14"></path>
    <path d="M19 2v4c0 1.38-1.13 2.5-2.5 2.5S14 7.38 14 6V2"></path>
    <path d="M17 22v-4c0-1.38-1.13-2.5-2.5-2.5S12 16.62 12 18v4"></path>
    <path d="M12 2v20"></path>
  </svg>
);

export const IconFlask = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 2v7.5L4.5 20H19.5L14 9.5V2h-4Z"></path>
    <path d="M8.5 2h7"></path>
    <path d="M6 16h12"></path>
  </svg>
);

export const IconCalendar = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

export const IconShield = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
);

export const IconTrendingUp = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);

export const IconFolder = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
  </svg>
);

export const IconBell = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
  </svg>
);

export const IconRuler = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21.3 8.7 8.7 21.3c-1 1-2.5 1-3.4 0l-2.6-2.6c-1-1-1-2.5 0-3.4L15.3 2.7c1-1 2.5-1 3.4 0l2.6 2.6c1 1 1 2.5 0 3.4Z"></path>
    <path d="m14 10 4-4"></path>
    <path d="m11 13 4-4"></path>
    <path d="m8 16 4-4"></path>
    <path d="m5 19 4-4"></path>
  </svg>
);

export const IconScale = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M12 7v5"></path>
    <path d="M17 12h-2"></path>
  </svg>
);

export const IconActivity = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
  </svg>
);

export const IconHeart = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
  </svg>
);

export const IconAlertTriangle = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
    <line x1="12" y1="9" x2="12" y2="13"></line>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
);

export const IconFileText = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <line x1="10" y1="9" x2="8" y2="9"></line>
  </svg>
);

export const IconUser = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

export const IconPhone = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

export const IconClock = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

/* ==========================================================================
   COLUMNS CONFIGURATIONS
   ========================================================================== */

export const studyHistoryColumns = [
  {
    key: "studycode",
    label: "Study Code",
    cell: (row: any) => <span className={styles.historyStudyNo}>{row.studycode || row.studyCode || "-"}</span>,
  },
  {
    key: "sponsorname",
    label: "Sponsor Name",
    cell: (row: any) => <span>{row.sponsorname || "-"}</span>,
  },
  {
    key: "completeddate",
    label: "Study Completion Date",
    cell: (row: any) => <span>{row.completeddate ? formatDate(row.completeddate) : "-"}</span>,
  },
  {
    key: "status",
    label: "Status",
    cell: (row: any) => <Commonbadge status={row.status || row.studyStatus || "Active"} style={{ width: "85px" }} />,
  },
  {
    key: "washoutdays",
    label: "Washout Days",
    cell: (row: any) => (
      <span>
        {row.washoutdays !== undefined && row.washoutdays !== null
          ? `${row.washoutdays} days`
          : row.washoutDays !== undefined && row.washoutDays !== null
          ? `${row.washoutDays} days`
          : "-"}
      </span>
    ),
  },
];

